/**
 * How long a Watchlist removal waits on the buyer's note read before it goes
 * ahead as if the note could not be read: today's toast copy, and the server
 * keeps the note.
 */
export const NOTE_READ_TIMEOUT_MS = 2000
